module.exports = __webpack_public_path__ + "img/IFCC-white.037733ed.png";